<template>
  <v-dialog :value="sectionEditor.show" :width="1200" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <h3 class="label-input">Section Name</h3>
          <v-text-field v-model="fields.title" label="Name" />
        </div>
        <div class="mb-4">
          <h3 class="label-input">Header Content</h3>
          <ckeditor :editor="editor" v-model="fields.header" :config="editorConfig" />
        </div>
        <div class="mb-6">
          <label class="label-input"> Button </label>
          <div class="group-item">
            <v-row class="mt-2">
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.button.text" label="Text" dense hide-details />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  type="number"
                  v-model.number="fields.button.borderRadius"
                  label="Border Radius"
                  min="0"
                  dense
                  hide-details
                  suffix="px"
                  :rules="[v => v >= 0 || 'Border Radius must be greater than or equal 0']"
                />
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="mb-6">
          <label class="label-input"> Footer Content </label>
          <ckeditor :editor="editor" v-model="fields.footer" :config="editorConfig" />
        </div>
        <div>
          <label class="label-input">Section Settings</label>
          <div class="group-item">
            <div class="mb-6">
              <div class="font-weight-medium">Spacing</div>
              <v-row>
                <v-col cols="6">
                  <v-checkbox v-model="fields.topPadding" label="Top Spacing" dense hide-details />
                </v-col>
                <v-col cols="6">
                  <v-checkbox v-model="fields.bottomPadding" label="Bottom Spacing" dense hide-details />
                </v-col>
              </v-row>
            </div>
            <div class="mb-6">
              <div class="font-weight-medium mb-3">Container Colors</div>
              <v-row>
                <v-col md="4" cols="12">
                  <ColorPicker
                    v-model="fields.colors.backgroundColor"
                    name="backgroundColor"
                    label="Background Color"
                    default-color="#ffffff"
                  />
                </v-col>
                <v-col md="4" cols="12">
                  <ColorPicker
                    v-model="fields.colors.containerBackgroundColor"
                    name="containerBackgroundColor"
                    label="Container Background Color"
                    default-color="#cb6387"
                  />
                </v-col>
                <v-col md="4" cols="12">
                  <ColorPicker
                    v-model="fields.colors.textColor"
                    name="textColor"
                    label="Text Color"
                    default-color="#ffffff"
                  />
                </v-col>
              </v-row>
            </div>
            <div>
              <div class="font-weight-medium mb-3">Button Colors</div>
              <v-row>
                <v-col md="6" cols="12">
                  <ColorPicker
                    v-model="fields.button.backgroundColor"
                    name="buttonBackgroundColor"
                    label="Button Background Color"
                    default-color="#181b1d"
                  />
                </v-col>
                <v-col md="6" cols="12">
                  <ColorPicker
                    v-model="fields.button.textColor"
                    name="textColor"
                    label="Button Text Color"
                    default-color="#ffffff"
                  />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save Changes</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { updateHtmlFromData } from '../common/html/update';
import ColorPicker from './common/color-picker.vue';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';

export default {
  name: 'sectionMoneyBackGuaranteeEditor',
  components: {
    ColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Money Back Guarantee Section',
        header: '',
        footer: '',
        button: {
          text: 'CLAIM NOW',
          borderRadius: 40,
          textColor: '#ffffff',
          backgroundColor: '#181b1d',
        },
        colors: {
          backgroundColor: '#ffffff',
          containerBackgroundColor: '#cb6387',
          textColor: '#ffffff',
        },
        topPadding: true,
        bottomPadding: true,
      },
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updatedSection = {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtmlFromData.sectionMoneyBackGuarantee(this.sectionEditor.section.html, this.fields),
      };
      this.$emit('update:section', updatedSection);
      this.handleClosePopup();
    },
  },

  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
};
</script>

<style scoped lang="scss">
::v-deep .ck-editor__editable_inline {
  min-height: 100px !important;
}
::v-deep .ck-editor__editable {
  min-height: 100px !important;
}

.feature-thumbnail {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

::v-deep .v-text-field--outlined {
  .v-input__control {
    .v-input__slot {
      min-height: 40px;
    }
  }
}

::v-deep .v-textarea {
  &.v-text-field--outlined {
    .v-input__control {
      .v-input__slot {
        min-height: 80px;
      }
    }
  }
}

.video-wrapper {
  background: rgba(0, 0, 0, 0.767);
  .wrap-video {
    max-width: 300px;
    margin: 0 auto;
    video {
      display: block;
      width: 100%;
      height: auto;
    }
  }
}
</style>
